import React from 'react';

const rows = [
  {
    feature: 'Instant POS + Payment Integration',
    does: 'Pulls clean transaction data from Moniepoint, OPay, PalmPay, Nomba',
    win: 'No more data headaches',
  },
  {
    feature: 'AI-Powered Customer Segmentation',
    does: 'Groups buyers by behavior, not guesswork',
    win: 'Feels like you have a marketing genius on staff',
  },
  {
    feature: 'Personalized WhatsApp & SMS Flows',
    does: 'Writes, sends, and optimizes sequences automatically',
    win: 'Customers feel seen and valued',
  },
  {
    feature: 'Smart Reorder Nudges',
    does: 'Detects when stock is low or reorder window opens',
    win: 'Extra revenue while you sleep',
  },
  {
    feature: 'Ad Creative + Audience Optimizer',
    does: 'Turns your best customers into lookalike audiences',
    win: 'Lower cost, higher returns',
  },
  {
    feature: 'Real-time Performance Dashboard',
    does: 'Shows exactly which campaigns are printing money',
    win: 'Total confidence in every naira spent',
  },
];

const NgFeaturesTableSection = () => {
  return (
    <section id="features" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-3">
            Features that translate directly into growth.
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Every feature is designed to do one job: turn silent POS data into predictable, repeat revenue.
          </p>
        </div>

        <div className="overflow-x-auto rounded-3xl border border-gray-200 bg-white">
          <table className="min-w-full text-left text-sm text-gray-700">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 sm:px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-[0.16em]">
                  What You Get
                </th>
                <th className="px-4 sm:px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-[0.16em]">
                  What It Actually Does for You
                </th>
                <th className="px-4 sm:px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-[0.16em]">
                  Emotional Win
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'}
                >
                  <td className="align-top px-4 sm:px-6 py-3 font-semibold text-black">
                    {row.feature}
                  </td>
                  <td className="align-top px-4 sm:px-6 py-3 text-gray-700">
                    {row.does}
                  </td>
                  <td className="align-top px-4 sm:px-6 py-3 text-gray-800 font-medium">
                    {row.win}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default NgFeaturesTableSection;

